import * as Sentry from "@sentry/browser";

/** The CM breakdown lines did not add up to the CM the API returned, so the breakdown was withheld. */
export const reportCmBreakdownMismatch = (): void => {
  Sentry.captureMessage("CM breakdown lines did not reconcile with the contribution margin", { level: "warning", tags: { soilSight: "cmBreakdown" } });
};
